<div class="sidebar-actions cf-flex-row cf-justify-content-space-between cf-gap-10">
  <!-- This div contains the multi-edit mode entity type selection form -->
  <div class="multi-edit-selector" *ngIf="productSidebarOpened$ | async">
    <ng-container *ngIf="multiEditSelectionEnabled$ | async">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-select
          [formControl]="multiEditSelectionModeControl"
          [placeholder]="'UI.MultiEdit.SelectComponent' | translate"
          [panelWidth]="''"
        >
          <mat-option *ngFor="let item of multiEditSelectionModeOptions$ | async | productTreeOrderByName" [value]="item.item.Value">
            {{ item.item.NameId | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </div>

  <!-- This div contains the action buttons -->
  <div class="cf-flex-row cf-justify-content-end cf-gap-10">
    <div *ngIf="(productSidebarOpened$ | async) && copyState === true">
      <button mat-button (click)="cancelCopy()">{{ 'UI.Product.Action.CancelCopy' | translate }}</button>
    </div>

    <div *ngIf="productSidebarOpened$ | async">
      <button
        mat-icon-button
        (click)="toggleMultiEdit()"
        [matTooltip]="((multiEditSelectionEnabled$ | async) ? 'UI.MultiEdit.Close' : 'UI.MultiEdit.Open') | translate"
        [class.active]="multiEditSelectionEnabled$ | async"
        matTooltipPosition="above"
      >
        <mat-icon>density_small</mat-icon>
      </button>
    </div>

    <div *ngIf="productSidebarOpened$ | async">
      <div *ngIf="!allExpanded()">
        <button mat-icon-button (click)="expandAll()" [matTooltip]="'UI.Common.Action.ExpandAll' | translate" matTooltipPosition="above">
          <mat-icon svgIcon="double_arrow_down"></mat-icon>
        </button>
      </div>
      <div *ngIf="allExpanded()">
        <button
          mat-icon-button
          (click)="collapseAll()"
          [matTooltip]="'UI.Common.Action.CollapseAll' | translate"
          matTooltipPosition="above"
        >
          <mat-icon svgIcon="double_arrow_up"></mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="productSidebarOpened$ | async">
      <button
        mat-icon-button
        (click)="onChangeProductSidebarOpened(false)"
        [matTooltip]="'UI.Common.Action.CloseSidebar' | translate"
        matTooltipPosition="above"
      >
        <mat-icon svgIcon="arrow_back"></mat-icon>
      </button>
    </div>
    <div *ngIf="(productSidebarOpened$ | async) === false">
      <button
        mat-icon-button
        (click)="onChangeProductSidebarOpened(true)"
        [matTooltip]="'UI.Common.Action.OpenSidebar' | translate"
        matTooltipPosition="above"
      >
        <mat-icon svgIcon="arrow_forward"></mat-icon>
      </button>
    </div>
  </div>
</div>
<mat-tree
  *ngIf="productSidebarOpened$ | async"
  [dataSource]="dataSource"
  [treeControl]="treeControl"
  [trackBy]="trackBy"
  class="entity-tree ac-tree product-tree"
>
  <!-- This is invisible tree node for Message type nodes -->
  <mat-tree-node *matTreeNodeDef="let node; when: isMessage" style="display: none"> </mat-tree-node>
  <!-- This is the tree node template for leaf nodes -->
  <mat-tree-node
    *matTreeNodeDef="let node; when: isNotMessage && hasNoOrOnlyMessageChildren"
    matTreeNodeToggle
    id="{{ node?.Id }}"
    class="ac-tree-node ac-tree-leaf-node"
    [ngClass]="{ 'ac-tree-node-selected': isSelected(node) }"
  >
    <div
      class="mat-tree-node cf-flex-row cf-justify-content-space-between cf-align-items-center"
      (click)="treeNodeClicked(node)"
      [ngClass]="{ 'ac-tree-root-node': isRoot(node), 'is-root-child': isRootChild(node) }"
    >
      <!-- use a disabled button to provide padding for tree leaf -->
      <div class="cf-flex-row cf-align-items-center">
        <button mat-icon-button disabled *ngIf="!isRoot(node) && !isRootChild(node)"></button>
        <span>{{ getName(node) }}</span>
        <span class="icons-container">
          <span *ngIf="showIcon(node, 0)"><mat-icon class="ac-message-icon error" svgIcon="error"></mat-icon></span>
          <span *ngIf="showIcon(node, 1)"><mat-icon class="ac-message-icon warning" svgIcon="warning"></mat-icon></span>
          <span *ngIf="showIcon(node, 2)"><mat-icon class="ac-message-icon info" svgIcon="info"></mat-icon></span>
        </span>
      </div>

      <ng-container *ngIf="multiEditShouldShowCheckboxes$ | async">
        <app-multi-edit-entity-selection-checkbox
          [status]="multiEditSelectionStatuses[node.Id]"
          (changed)="multiEditCheckboxStateChange(node, $event)"
        ></app-multi-edit-entity-selection-checkbox>
      </ng-container>
      <button
        *ngIf="copyState === false && (multiEditSelectionEnabled$ | async) === false"
        mat-icon-button
        [matMenuTriggerFor]="itemMenu"
        [matMenuTriggerData]="{ node: node }"
        [disabled]="!(((canDelete$(node.Id) | async) && !isRoot(node)) || (addableReferences$(node.Id) | async).length > 0)"
        (click)="$event.stopPropagation()"
      >
        <mat-icon svgIcon="more_vert"></mat-icon>
      </button>

      <button
        *ngIf="(canAdd$(node.Id, nodeKeyToCopy) | async) && copyState === true"
        mat-icon-button
        (click)="pasteNode(node)"
        [matTooltip]="'UI.Common.Action.Paste' | translate"
        matTooltipPosition="above"
      >
        <mat-icon svgIcon="content_paste"></mat-icon>
      </button>
    </div>
  </mat-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-nested-tree-node
    [ngClass]="{ 'entity-nested-levels': !isRoot(node) && !isRootChild(node) }"
    *matTreeNodeDef="let node; when: isNotMessage && hasNonMessageChildren"
    id="{{ node?.Id }}"
    [trackBy]="trackBy"
  >
    <div
      class="mat-tree-node ac-tree-node cf-flex-row cf-justify-content-space-between cf-align-items-center"
      (click)="treeNodeClicked(node)"
      [ngClass]="{
        'ac-tree-node-selected': isSelected(node),
        'ac-tree-node-child-is-selected': isChildSelected(node),
        'ac-tree-root-node': isRoot(node),
        'ac-tree-node-inactive': (multiEditShouldShowCheckboxes$ | async) && multiEditSelectionModeControl.value !== node.EntityTypeKey
      }"
    >
      <div class="cf-flex-row cf-align-items-center">
        <button *ngIf="!isRoot(node)" mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.Key">
          <mat-icon class="mat-icon-rtl-mirror">
            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
        </button>

        <span [ngClass]="{ 'mat-headline-6': isRoot(node) }">
          {{ getName(node) }}
        </span>

        <span class="icons-container">
          <span *ngIf="showIcon(node, 0)"><mat-icon class="ac-message-icon error" svgIcon="error"></mat-icon></span>
          <span *ngIf="showIcon(node, 1)"><mat-icon class="ac-message-icon warning" svgIcon="warning"></mat-icon></span>
          <span *ngIf="showIcon(node, 2)"><mat-icon class="ac-message-icon info" svgIcon="info"></mat-icon></span>
        </span>
      </div>

      <ng-container *ngIf="multiEditShouldShowCheckboxes$ | async">
        <app-multi-edit-entity-selection-checkbox
          [status]="multiEditSelectionStatuses[node.Id]"
          (changed)="multiEditCheckboxStateChange(node, $event)"
        ></app-multi-edit-entity-selection-checkbox>
      </ng-container>
      <button
        *ngIf="copyState === false && (multiEditSelectionEnabled$ | async) === false"
        mat-icon-button
        [matMenuTriggerFor]="itemMenu"
        [matMenuTriggerData]="{ node: node }"
        [disabled]="!(((canDelete$(node.Id) | async) && !isRoot(node)) || (addableReferences$(node.Id) | async).length > 0)"
        (click)="$event.stopPropagation()"
      >
        <mat-icon svgIcon="more_vert"></mat-icon>
      </button>

      <button
        *ngIf="(canAdd$(node.Id, nodeKeyToCopy) | async) && copyState === true"
        mat-icon-button
        (click)="pasteNode(node)"
        [matTooltip]="'UI.Common.Action.Paste' | translate"
        matTooltipPosition="above"
      >
        <mat-icon svgIcon="content_paste"></mat-icon>
      </button>
    </div>
    <div [ngClass]="{ 'entity-tree-invisible': !treeControl.isExpanded(node) }" role="group">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>

<mat-menu #itemMenu="matMenu" xPosition="before" yPosition="below">
  <ng-template matMenuContent let-node="node">
    <button mat-menu-item *ngFor="let ref of addableReferences$(node.Id) | async" (click)="addNode(node, ref)">
      {{ 'UI.Common.Action.Add' | translate }} {{ ref.TextId | translate }}
    </button>
    <button mat-menu-item *ngIf="(canAddInTheTree$(node.EntityTypeKey) | async) && !isRoot(node)" (click)="copyNode(node)">
      {{ 'UI.Common.Action.Copy' | translate }}
    </button>
    <button mat-menu-item *ngIf="isHood(node)" (click)="openCopyToProjectDialog(node)">
      {{ 'UI.ProductAction.CopyToAnotherProject' | translate }}
    </button>
    <button mat-menu-item *ngIf="(canDelete$(node.Id) | async) && !isRoot(node)" (click)="deleteNode(node)">
      {{ 'UI.Common.Action.Delete' | translate }}
    </button>
  </ng-template>
</mat-menu>
